// extracted by mini-css-extract-plugin
export default {"loaderContainer":"loader_loaderContainer__ipmFe","loaderBox":"loader_loaderBox__zqR1p","loader":"loader_loader__1AOoV"};